import CustomerTitle from './CustomerTitle'

export default CustomerTitle
